module.exports = __webpack_public_path__ + "static/media/requiredDocs.99122083.svg";